import { useAuth } from "../context/AuthContext";
import { StatusMessage } from "../components/ui/StatusMessage";

export function NotFoundPage() {
  const { isAuthenticated, role } = useAuth();

  const destination = isAuthenticated
    ? role === "admin"
      ? "/admin"
      : "/student"
    : "/";

  const actionLabel = isAuthenticated
    ? role === "admin"
      ? "Go to admin panel"
      : "Go to dashboard"
    : "Go to home";

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-background">
      <div className="w-full max-w-md">
        <StatusMessage
          variant="warning"
          title="Page not found"
          message="The page you are looking for does not exist or has been moved."
          action={{
            label: actionLabel,
            href: destination,
          }}
        />
      </div>
    </div>
  );
}
